import styles from './Hero.module.css';
import { Container, Row, Col, Button,Offcanvas, Form ,FormControl} from 'react-bootstrap';
import React, {useState, useEffect} from 'react'

import heroslide from '../../assets/imgs/heroslide.png';

import img1 from '../../assets/imgs/heroslider.png';
import img2 from '../../assets/imgs/img2.png';
import img3 from '../../assets/imgs/img3.png';
import img4 from '../../assets/imgs/img4.png';
import img5 from '../../assets/imgs/img5.png';
import img6 from '../../assets/imgs/img6.png';
import img7 from '../../assets/imgs/img7.png';

import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

const responsive = {
    0: { items: 1 },
    568: { items: 1 },
    1024: { items: 1 },
};

const responsive1 = {
    0: { items: 1 },
    568: { items: 1 },
    1024: { items: 1},
};

const items = [
  <div className="item" data-value="1">
  <img src={img1} className={` mt-5 rounded img-fluid ${styles.img4}`} />
  </div>,
//   <div className="item" data-value="2"> 
//   <img src={img5} className={`shadow me-1 rounded ${styles.img5}`} />
//    </div>,
//   <div className="item" data-value="3">  
//   <img src={img6} className={`shadow me-1 rounded ${styles.img6}`} />
//    </div>,
//   <div className="item" data-value="4">  
//   <img src={img7}  className={`shadow me-1 rounded ${styles.img7}`}/>
  
//    </div>,
//     <div className="item" data-value="5">  
//     <img src={img4} className={`shadow  me-1 rounded ${styles.img4}`} />
  
//    </div>,
//     <div className="item" data-value="6">  
//    <img src={img5} className={`shadow me-1 rounded  ${styles.img5}`} />

  
//    </div>

];

const items1 = [
  
     <div className="item1" data-value="1">
       <img src={''} alt='proj flyer1' className={`mb-3 mt-lg-5  ${styles.heroimg}`}/>
     </div>,
//      <div className="item1" data-value="2">
//      <img src={heroslide} alt='proj flyer1' className={`mb-3 mt-lg-5  ${styles.heroimg}`}/>
//    </div>,
//    <div className="item1" data-value="3">
//    <img src={heroslide} alt='proj flyer1' className={`mb-3 mt-lg-5   ${styles.heroimg}`}/>
//  </div>
  
  ];

export const Hero = () => {
   const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

 
  return (
    <div>
        <Container>
            <Row>
                <Col lg={5} sm={12} xs={12} md={5} className={`${styles.col1}`}>
                    <div>
                        <h1 className={`${styles.heroTitle}`}>Save Time Negotiating Web/App Projects</h1>
                        <p className={`${styles.heroText}`}>Build with your budget, only N10,000/$20 per web page or N15,000/$37.5 per app functionalities. (Start with 3 pages or 20 functionalities)</p>
                    
                    </div>
                    <div>
                        <Form className={`d-flex`}>
                            <FormControl type='email' placeholder='Enter your Email Address' className={`${styles.formctr}`}/>
                            <Button variant='primary' className={` ms-2 ${styles.btn1}`}>Get Started Free</Button>
                        </Form>
                    </div>
            <Button variant='primary' className={`${styles.offcanvasbtn}`} onClick={handleShow} placement={'end'}>Pricing Calculator</Button>
                <Offcanvas show={show} onHide={handleClose}>
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>ullweb Do Growth Conference</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        Hello world
                    </Offcanvas.Body>
                </Offcanvas>
                </Col>
                <Col lg={7}  sm={12} xs={12} md={5}>
                    <Row className={`${styles.imgrows}`}>
                    <Col xs={12} sm={12}>
{/* 
                    <AliceCarousel
                            autoPlay
                            autoPlayControls
                            autoPlayStrategy="none"
                            autoPlayInterval={3000}
                            infinite
                            mouseTracking
                            items={items1}
                            responsive={responsive1}
                            controlsStrategy="alternate"
                            disableButtonsControls
                            disableSlideInfo
                            disableDotsControls
                            className={`mb-2`}
                        /> */}
                    </Col>
                    {/* <Col>
                    <div>
                        <img src={img2} alt='proj flyer1' className={`img-fluid  ${styles.img2}`}/>
                    </div>
                    </Col>
                    <Col>
                    <div>
                        <img src={img3} alt='proj flyer1' className={`img-fluid  shadow ${styles.img3}`}/>
                    </div>
                    </Col>   */}
                    <div className={`mt-lg-4${styles.imgslide}`} >
                    <AliceCarousel
                            autoPlay
                            autoPlayControls
                            autoPlayStrategy="none"
                            autoPlayInterval={3000}
                            infinite
                            mouseTracking
                            items={items}
                            responsive={responsive}
                            controlsStrategy="alternate"
                            className={`mt-4`}
                            // value='Medihub UI/UX Project by Sandy Oluwatobi (ullweb.com/sandytobi)'
                        />
                  <p className={`${styles.slidetxt}`}>Medihub UI/UX Project by Sandy Oluwatobi (<a className={`${styles.a}`} href='ullweb.com/sandytobi/' >ullweb.com/sandytobi</a>)</p>
                    </div>                  
                    </Row>  
                               
                </Col>   

            </Row> 

        </Container>

        
        
    </div>
  )
}
